import React from "react";
import HcpIsi from "../../hcp/isi/isi-content"

export default function PatientIsi() {
  return (
    <HcpIsi />
  );
}
